import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo-without-text.png'


const _hoisted_1 = { class: "container mx-auto px-6 relative" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center w-1/3" }
const _hoisted_4 = { class: "hidden lg:flex items-center justify-center w-1/3" }
const _hoisted_5 = { class: "flex items-center space-x-12" }
const _hoisted_6 = ["aria-expanded"]
const _hoisted_7 = {
  key: 0,
  class: "lg:hidden fixed inset-0 z-[101]"
}

import { ref, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'PageHeader',
  setup(__props) {

const header = ref<HTMLElement | null>(null);
const scrolled = ref(false);
const atTop = ref(true);
const mobileMenuOpen = ref(false);
const route = useRoute();

const navItems = [
  { to: '/#features', text: 'Fonctionnalités' },
  { to: '/#partenaires', text: 'Partenaires' },
  // { to: '/about', text: 'À propos' },
  // { to: '/#how-it-works', text: 'Comment ça marche' },
  // { to: '/#pricing', text: 'Tarifs' },
  { to: '/contact', text: 'Contact' },
  { to: '/conditions', text: 'Conditions' },
];

const isActive = (path: string) => {
  if (path.startsWith('/#')) {
    return route.path === '/' && route.hash === path.substring(1);
  }
  return route.path === path;
};

const handleScroll = () => {
  const scrollPosition = window.scrollY;
  scrolled.value = scrollPosition > 50;
  atTop.value = scrollPosition <= 10;
};

const toggleMobileMenu = () => {
  mobileMenuOpen.value = !mobileMenuOpen.value;
  document.body.style.overflow = mobileMenuOpen.value ? 'hidden' : '';
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      ref_key: "header",
      ref: header,
      class: _normalizeClass(["fixed w-full z-[100] transition-all duration-300", [scrolled.value ? 'py-4 bg-[#1E2652]/70 backdrop-blur-sm' : 'py-4', 
                  atTop.value ? 'py-4 bg-[#1E2652]/90 backdrop-blur-sm' : 'bg-[#1E2652]/70 backdrop-blur-sm']])
    }, [
      _createElementVNode("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "flex items-center"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "PadelGo Logo",
                  class: "w-10 h-10 mr-3"
                }, null, -1),
                _createElementVNode("div", { class: "text-3xl flex items-center" }, [
                  _createElementVNode("span", { class: "text-white font-light" }, "Padel"),
                  _createElementVNode("span", { class: "text-[#B7E000] font-semibold" }, "Go")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
                return _createVNode(_component_router_link, {
                  key: item.to,
                  to: item.to,
                  class: _normalizeClass(["nav-link relative text-white/90 hover:text-white transition-all duration-300 py-2", { 'active': isActive(item.to) }])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-lg font-light tracking-wider transition-all duration-300", { 'text-xl text-[#B7E000] font-medium': isActive(item.to) }])
                    }, _toDisplayString(item.text), 3),
                    _createElementVNode("span", {
                      class: _normalizeClass(["nav-line", { 'w-full': isActive(item.to) }])
                    }, null, 2)
                  ]),
                  _: 2
                }, 1032, ["to", "class"])
              }), 64))
            ])
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hidden lg:flex w-1/3 justify-end" }, [
            _createElementVNode("a", {
              href: "https://manager.padelgo.ma",
              target: "_blank",
              rel: "noopener noreferrer",
              class: "bg-[#B7E000] text-[#1E2652] font-semibold px-8 py-3 rounded-full hover:opacity-90 transition-all duration-300 text-base"
            }, " Espace club ")
          ], -1)),
          _createElementVNode("button", {
            onClick: toggleMobileMenu,
            class: "lg:hidden relative w-14 h-14 text-white focus:outline-none",
            "aria-label": "Toggle mobile menu",
            "aria-expanded": mobileMenuOpen.value
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["menu-icon", { 'menu-icon--active': mobileMenuOpen.value }])
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "menu-icon__line" }, null, -1),
              _createElementVNode("div", { class: "menu-icon__line" }, null, -1)
            ]), 2)
          ], 8, _hoisted_6)
        ])
      ])
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (mobileMenuOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "absolute inset-0 bg-[#1E2652]/90 backdrop-blur-sm transition-opacity duration-300 opacity-100",
              onClick: toggleMobileMenu
            }),
            _createElementVNode("div", {
              onClick: toggleMobileMenu,
              class: "fixed inset-0 flex items-center justify-center transition-opacity duration-300 opacity-100"
            }, [
              _createElementVNode("button", {
                onClick: _withModifiers(toggleMobileMenu, ["stop"]),
                class: "absolute top-6 right-6 text-white hover:text-[#B7E000] transition-colors duration-300",
                "aria-label": "Close menu"
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: "h-8 w-8",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12"
                  })
                ], -1)
              ])),
              _createElementVNode("ul", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                class: "flex flex-col items-center space-y-8 p-8 w-11/12 max-w-sm"
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
                  return _createElementVNode("li", {
                    key: item.to
                  }, [
                    _createVNode(_component_router_link, {
                      to: item.to,
                      class: _normalizeClass(["text-white text-xl font-light tracking-wider hover:text-[#B7E000] transition-colors duration-300", { 'text-[#B7E000]': isActive(item.to) }]),
                      onClick: toggleMobileMenu
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.text), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"])
                  ])
                }), 64))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})